import React from "react";
import ShoppingCartComp from "../components/ShoppingCart/ShoppingCartComp";
const ShoppingCart = () => {
  return (
    <div>
      <ShoppingCartComp />
    </div>
  );
};

export default ShoppingCart;
